import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Location } from '../../model/location.model';
import { SERVER_API_URL } from '../../../app.constants';
import { ParamContext } from '../../service/param.context';
import { InventoryUnit } from '../model/inventory-unit.model';
import { PaginatedResponse } from '../../study/service/study-entry.service';
import { StudyTransactionsRequest } from './study-transaction-request.model';
import { StudyTransactionModel } from './study-transaction.model';
import { TransactionType } from './transaction-type.model';
import { TransactionStatus } from './transaction-status.model';
import { EnableLoadingIndicator, EnableSavingIndicator } from '../../loading-indicator';

@Injectable({ providedIn: 'root' })
export class InventoryService {

    constructor(private http: HttpClient,
                private paramContext: ParamContext,
                private router: Router) {
    }

    queryUnits(): Observable<InventoryUnit[]> {
        const cropName = this.paramContext.cropName;
        return this.http.get<InventoryUnit[]>(SERVER_API_URL + `crops/${cropName}/inventory-units`,
            { observe: 'response', context: new HttpContext().set(EnableLoadingIndicator, true) }).pipe(map((res: HttpResponse<InventoryUnit[]>) => res.body));
    }

    queryTransactionTypes(): Observable<TransactionType[]> {
        const cropName = this.paramContext.cropName;
        return this.http.get<TransactionType[]>(SERVER_API_URL + `crops/${cropName}/transaction-types`,
            { observe: 'response', context: new HttpContext().set(EnableLoadingIndicator, true) }).pipe(map((res: HttpResponse<TransactionType[]>) => res.body));
    }

    queryTransactionStatusTypes(): Observable<TransactionStatus[]> {
        const cropName = this.paramContext.cropName;
        return this.http.get<TransactionStatus[]>(SERVER_API_URL + `crops/${cropName}/transaction-status-types`,
            { observe: 'response', context: new HttpContext().set(EnableLoadingIndicator, true) }).pipe(map((res: HttpResponse<TransactionStatus[]>) => res.body));
    }

    queryLocation(requestLocation: any): Observable<Location[]> {
        const cropName = this.paramContext.cropName;
        const programUUID = this.paramContext.programUUID;
        return this.http.get<Location[]>(SERVER_API_URL + `crops/${cropName}/locations?programUUID=` + programUUID, {
            params: requestLocation,
            observe: 'response',
            context: new HttpContext().set(EnableLoadingIndicator, true)
        }).pipe(map((res: HttpResponse<Location[]>) => res.body));
    }

    searchStudyTransactions(studyId: number, searchRequest: StudyTransactionsRequest, page?: number, pageSize?: number, sort?: string) {
        let url = `${SERVER_API_URL}crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/transactions/search` + ((page !== undefined && pageSize !== undefined) ? '?page=' + page + '&size=' + pageSize : '');
        url += (sort) ? '&sort=' + sort : '';
        return this.http.post<PaginatedResponse<StudyTransactionModel>>(url, searchRequest, { observe: 'response', context: new HttpContext().set(EnableLoadingIndicator, true) }).pipe(
            map(response => {
                return {
                    data: response.body || [],
                    filteredCount: Number(response.headers.get('X-Filtered-Count')),
                    totalCount: Number(response.headers.get('X-Total-Count')),
                    page: page,
                    size: pageSize
                } as PaginatedResponse<StudyTransactionModel>;
            })
        );
    }

    cancelStudyTransaction(studyId: number, request: any) {
        const url = `${SERVER_API_URL}crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/transactions/cancellation`;
        return this.http.post(url, request, { context: new HttpContext().set(EnableSavingIndicator, true) });
    };
}


